import {Injectable, inject} from '@angular/core';
import {PortfolioAsset} from '../models/portfolio-asset';
import {Observable} from 'rxjs';
import {PortfolioOfftake} from '../models/portfolio-offtake';
import {PortfolioVersion} from '../models/portfolio-version';
import {PriceDataset} from '../models/price-dataset';
import {SimulationResult} from '../models/simulation-result';
import {environment} from '@environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PortfolioSimulatorService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.backend_url;

  getVersions(priceDataset?: string): Observable<PortfolioVersion[]> {
    const params = priceDataset
      ? new HttpParams().set('priceDataset', priceDataset)
      : undefined;
    return this.http.get<PortfolioVersion[]>(
      `${this.baseUrl}/portfolio-simulator/versions`,
      params ? {params} : {},
    );
  }

  getAssets(versionName: string): Observable<PortfolioAsset[]> {
    const params = new HttpParams().set('versionName', versionName);
    return this.http.get<PortfolioAsset[]>(
      `${this.baseUrl}/portfolio-simulator/assets`,
      {params},
    );
  }

  getOfftakes(versionName: string): Observable<PortfolioOfftake[]> {
    const params = new HttpParams().set('versionName', versionName);
    return this.http.get<PortfolioOfftake[]>(
      `${this.baseUrl}/portfolio-simulator/offtakes`,
      {params},
    );
  }

  getPriceDatasets(portfolioVersion?: string): Observable<PriceDataset[]> {
    const params = portfolioVersion
      ? new HttpParams().set('portfolioVersion', portfolioVersion)
      : undefined;
    return this.http.get<PriceDataset[]>(
      `${this.baseUrl}/portfolio-simulator/price-datasets`,
      params ? {params} : {},
    );
  }

  getSimulationResults(
    versionName: string,
    weatherYear: string,
  ): Observable<SimulationResult[]> {
    const params = new HttpParams()
      .set('versionName', versionName)
      .set('weatherYear', weatherYear);
    return this.http.get<SimulationResult[]>(
      `${this.baseUrl}/portfolio-simulator/results`,
      {params},
    );
  }
}
